var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isCalenderIcon
    ? _c(
        "div",
        { staticClass: "relative flex items-center" },
        [
          _c("Datepicker", {
            staticClass: "datepicker",
            class: _vm.inputClass,
            style: { color: _vm.color },
            attrs: {
              typeable: "",
              id: _vm.id,
              "input-class": _vm.classObject,
              value: _vm.value ? new Date(_vm.value + "T12:00:00") : null,
              "calendar-class": _vm.calendarClass,
              "open-date": _vm.openDate,
              placeholder: _vm.placeholder,
              "disabled-dates": _vm.disabledDates,
              highlighted: _vm.highlightedDates,
              disabled: _vm.disabled,
              format: _vm.format,
            },
            on: { selected: _vm.updateValue },
          }),
          _vm.isCalenderIcon
            ? _vm._t(
                "calendericon",
                function () {
                  return [
                    _c("CalendarIcon", { staticClass: "absolute right-3" }),
                  ]
                },
                { cls: "absolute right-3 " }
              )
            : _vm._e(),
        ],
        2
      )
    : _c("Datepicker", {
        staticClass: "datepicker",
        class: _vm.inputClass,
        style: { color: _vm.color },
        attrs: {
          typeable: "",
          id: _vm.id,
          "input-class": _vm.classObject,
          value: _vm.value ? new Date(_vm.value + "T12:00:00") : null,
          "calendar-class": _vm.calendarClass,
          "open-date": _vm.openDate,
          placeholder: _vm.placeholder,
          "disabled-dates": _vm.disabledDates,
          highlighted: _vm.highlightedDates,
          disabled: _vm.disabled,
          format: _vm.format,
        },
        on: { selected: _vm.updateValue },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }